const { exclusiveRightColumn } = require('./workOrderPanelPlacement');

const STORAGE_KEY = 'pixie-navbar-open-panels';

const QUICK_EMAIL_ROUTES = ['/properties', '/lease-search'];

const NAV_PANEL_FLAGS = [
  'showQuickEmail',
  'showMobileNotes',
  'showSmsInbox',
  'showWorkOrders',
  'showCashPosition',
  'showLockCodes',
  'showAppliances',
  'showPropertySummary',
  'showChatTool',
  'showQuarters',
  'showCollectorSetup',
  'showSurveySetup',
  'showRentMeSetup',
  'showLateFees',
  'showStaffSms',
  'showBulkEmail',
  'showPayrollPopup',
  'showVoiceMessages',
  'showHelpVideos',
  'showCalendarModal',
  'showChatBotMotd',
  'showFinancialSummary',
  'showNotesPanel',
  'showAceStatementImport',
  'showBrysonLawncareImport',
];

function getStorage(storage) {
  if (storage) return storage;
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch (_) {
    /* ignore */
  }
  return null;
}

function defaultNavPanelsForRoute(path) {
  if (path === '/properties') return ['showMobileNotes', 'showQuickEmail'];
  if (path === '/lease-search') return ['showQuickEmail'];
  return [];
}

function migrateNavPanelKey(key) {
  return key === 'showVoiceMemoPlayer' ? 'showVoiceMessages' : key;
}

function snapshotNavPanels(state) {
  return NAV_PANEL_FLAGS.filter((key) => !!(state && state[key]));
}

function applyNavPanels(openKeys) {
  const set = new Set((openKeys || []).map(migrateNavPanelKey));
  const next = {};
  for (const key of NAV_PANEL_FLAGS) {
    next[key] = set.has(key);
  }
  return next;
}

function filterNavPanelsForRoute(openKeys, path) {
  const filtered = [
    ...new Set((openKeys || []).map(migrateNavPanelKey)),
  ].filter(
    (key) =>
      NAV_PANEL_FLAGS.includes(key) &&
      (key !== 'showQuickEmail' || QUICK_EMAIL_ROUTES.includes(path)),
  );
  return exclusiveRightColumn(path, filtered);
}

function readNavPanelMap(storage) {
  const s = getStorage(storage);
  if (!s) return {};
  try {
    const raw = s.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (_) {
    return {};
  }
}

function writeNavPanelMap(storage, map) {
  const s = getStorage(storage);
  if (!s) return;
  try {
    s.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (_) {
    /* quota / private mode */
  }
}

function readNavPanelsForRoute(path, storage) {
  const map = readNavPanelMap(storage);
  if (!Object.prototype.hasOwnProperty.call(map, path)) {
    return filterNavPanelsForRoute(defaultNavPanelsForRoute(path), path);
  }
  return filterNavPanelsForRoute(map[path], path);
}

function writeNavPanelsForRoute(path, openKeys, storage) {
  const map = readNavPanelMap(storage);
  map[path] = filterNavPanelsForRoute(openKeys, path);
  writeNavPanelMap(storage, map);
}

function initialNavPanelFlags(path, storage) {
  return applyNavPanels(readNavPanelsForRoute(path, storage));
}

module.exports = {
  STORAGE_KEY,
  QUICK_EMAIL_ROUTES,
  NAV_PANEL_FLAGS,
  defaultNavPanelsForRoute,
  snapshotNavPanels,
  applyNavPanels,
  filterNavPanelsForRoute,
  readNavPanelsForRoute,
  writeNavPanelsForRoute,
  initialNavPanelFlags,
};
